/**
 * N226 - tabela simples (so leitura) das listas do Diagnostico Nuvem/App.
 * `rolagem` limita a altura: o detalhe de uma sync pode ter 2.000 requisicoes.
 */
import React from 'react';
import { SEM_DADOS } from '../../services/diagnosticoNuvemService';

interface TabelaProps {
  titulo: string;
  cabecalho: string[];
  linhas: React.ReactNode[][];
  rodape?: string;
  rolagem?: boolean;
}

export const Tabela = ({ titulo, cabecalho, linhas, rodape, rolagem }: TabelaProps) => (
  <div>
    <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{titulo}</h4>
    <div
      className={`overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 ${
        rolagem ? 'max-h-96 overflow-y-auto' : ''
      }`}
    >
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
        <thead className="bg-gray-50 dark:bg-gray-700/50 sticky top-0">
          <tr>
            {cabecalho.map((h) => (
              <th
                key={h}
                className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider whitespace-nowrap"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
          {linhas.length === 0 ? (
            <tr>
              <td colSpan={cabecalho.length} className="px-3 py-6 text-center text-gray-500 dark:text-gray-400">
                {SEM_DADOS}
              </td>
            </tr>
          ) : (
            linhas.map((linha, i) => (
              <tr key={i} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                {linha.map((celula, j) => (
                  <td key={j} className="px-3 py-2 text-gray-900 dark:text-gray-200 whitespace-nowrap tabular-nums">
                    {celula}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
    {rodape && <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{rodape}</p>}
  </div>
);
